import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-po-range',
  templateUrl: './po-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PoRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
